import InlineSearch from "@/components/yts/InlineSearch";

/**
 * The landing page's front door: a single wide pill that reads as "start your
 * search" before anything else. It is the same search field the header uses, so
 * typing and submitting runs the guide's normal keyword search.
 */
export default function HomeSearchPill() {
  return (
    <div className="relative z-20 border-t border-black/[0.06] bg-white px-4 pb-3 pt-3 dark:border-white/10 dark:bg-[#171719] sm:px-6 sm:py-4 lg:px-8">
      <div className="mx-auto w-full max-w-[1180px]">
        <InlineSearch variant="hero" />
      </div>
    </div>
  );
}